export default __webpack_public_path__ + "static/media/controller-gray.394d9a34.svg";